export * from './IPointsEstimationParams';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/PointsEstimation/index.ts